import { AbstractControl } from '@angular/forms';

export const STATE_ABBREVIATIONS = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export class StateCodeValidator {
  static format(c: AbstractControl): { [key: string]: any; } {
    if (!c.value || c.value.toString().trim().length === 0) {
      return null;
    }
    if (!STATE_ABBREVIATIONS.includes(c.value.toString().trim())) {
      return { stateCode: 'Must be valid uppercase state abbreviation.' };
    }
    return null;
  }
}
